import { isHoliday as isHolidayDE } from "feiertagejs"
import Holidays from "date-holidays"

import config from "config"

/**
 * Returns true if today is a public holiday for the configured resto country/region.
 */
export const isHolidayToday = () => {
  const today = new Date()

  if (config.address?.country === "BE") {
    const hd = new Holidays(config.address.country, config.address.region)
    return !!hd.isHoliday(today)
  }

  return isHolidayDE(today, config.address?.region ?? "ALL")
}
